// BranchesPageHeader/index.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  MenuItem,
  Menu,
  LinearProgress
} from '@material-ui/core';
import SettingIcon from '@material-ui/icons/Settings';
import { useParams } from 'react-router-dom';

import Page from '../Page';
import { useAuth0 } from '../../react-auth0-spa';
import ChangePasswordDialog from '../../containers/ChangePasswordDialog';
import MessageDisplay from '../../containers/MessageDisplay';

const useStyles = makeStyles((theme) => ({
  navbarContainer: {
    display: 'flex'
  },
  root: {
    flexGrow: 1
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  leftControls: {
    flexGrow: 1,
    display: 'flex'
  },
  title: {
    marginTop: 5
  },
  navigationLinks: {
    marginTop: 8,
    marginLeft: 40
  },
  homeButton: {
    textDecoration: 'none',
    fontSize: '14px',
    letterSpacing: '0.02857em',
    color: 'rgba(255,255,255,0.87)',
    textTransform: 'uppercase'
  },
  rightControls: {
    display: 'flex'
  },
  userName: {
    marginTop: 12,
    marginRight: 30,
    fontSize: 16
  },
  loginLogoutButtons: {},
  appbar: {
    background:
      'linear-gradient(90deg, rgba(44,107,178,1) 0%, rgba(20,29,120,1) 100%) !important'
  },
  settingsIcon: {
    color: theme.palette.tertiary.main
  },
  hastrakLogo: {
    width: 33,
    height: 38,
    display: 'inline-block',
    marginRight: 20
  }
}));

function BranchesPageHeader(props) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const { logout, user } = useAuth0();
  const {
    userFromDb,
    fetchBranchDetailsForUser,
    branch,
    isSavingEvent,
    isLoadingRecordsForTheEvent,
    isDeletingRecord,
    isSavingNewRecord,
    isSavingCourse,
    isLoadingRecordsForTheCourse,
    isDeletingCourseRecord,
    isLoadingCourses,
    isLoadingPersonnels,
    isLoadingEvents,
    isLoadingAccidents,
    viewBranchAsAdmin,
    fetchBranchDetailsByBranchId,
    onChangePassword,
    setLoggedInUser
  } = props;
  let { branchId } = useParams();

  React.useEffect(
    () => {
      setLoggedInUser(user);

      if (viewBranchAsAdmin) {
        fetchBranchDetailsByBranchId(branchId);
      } else {
        fetchBranchDetailsForUser(userFromDb.id);
      }
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [userFromDb, viewBranchAsAdmin, user]
  );

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleChangePasswordClick = () => {
    setAnchorEl(null);
    onChangePassword();
  };

  return (
    <React.Fragment>
      <ChangePasswordDialog />
      <MessageDisplay />

      <div className={classes.navbarContainer}>
        <AppBar position="fixed" className={classes.appbar}>
          <Page>
            <Toolbar>
              <div className={classes.leftControls}>
                <img
                  src="https://hastrak.co.nz/wp-content/uploads/2019/10/HasTrak-logo.png"
                  alt="HasTrak logo"
                  className={classes.hastrakLogo}
                />
                <Typography variant="h6" className={classes.title}>
                  {branch && `${branch.companyName} - ${branch.name}`}
                </Typography>
              </div>

              <div className={classes.rightControls}>
                <div className={classes.userName}>{user.name}</div>

                <div className={classes.loginLogoutButtons}>
                  <React.Fragment>
                    <IconButton
                      aria-label="show 4 new mails"
                      color="inherit"
                      onClick={handleMenu}
                      id="settings-button"
                    >
                      <SettingIcon
                        color="primary"
                        className={classes.settingsIcon}
                      />
                    </IconButton>
                    <Menu
                      id="menu-appbar"
                      anchorEl={anchorEl}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right'
                      }}
                      keepMounted
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right'
                      }}
                      open={open}
                      onClose={handleMenuClose}
                    >
                      <MenuItem
                        onClick={handleChangePasswordClick}
                        id="logout-menu-item"
                      >
                        Change Password
                      </MenuItem>
                      <MenuItem onClick={() => logout()} id="logout-menu-item">
                        Logout
                      </MenuItem>
                    </Menu>
                  </React.Fragment>
                </div>
              </div>
            </Toolbar>
          </Page>
          {isSavingEvent ||
          isLoadingRecordsForTheEvent ||
          isDeletingRecord ||
          isSavingNewRecord ||
          isLoadingRecordsForTheCourse ||
          isDeletingCourseRecord ||
          isLoadingCourses ||
          isLoadingPersonnels ||
          isLoadingEvents ||
          isLoadingAccidents ||
          isSavingCourse ? (
            <LinearProgress />
          ) : null}
        </AppBar>
      </div>
    </React.Fragment>
  );
}

BranchesPageHeader.propTypes = {
  // describe the component's prop types here
};

BranchesPageHeader.defaultProps = {
  // assign default props to the component here
};

export default BranchesPageHeader;
